import { OrganizationForm, UserOrganization } from '../../../../../types';
import { Button } from 'antd'
import { api } from '../../../../../api';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import { CustomInput, CustomTextarea } from '@components/FormFields';
import * as Yup from 'yup';
import { sendError, sendMessage } from '@util/helpers/notifications.helper';
import { addOrganization } from '@store/organization';
import "./AddUpdateForm.styles.css"

const validationSchema = Yup.object({
  title: Yup.string().required('Title is required!'),
});

interface Props {
  onCancel: () => void;
}

export const AddForm = ({ onCancel }: Props) => {
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const onSubmit = async (input: OrganizationForm) => {
    setLoading(true);

    try {

      const { data } = await api.post<UserOrganization>('/organizations', input);
      if (!data) throw new Error('');

      dispatch(addOrganization(data));

      sendMessage('Organization added successfully!');

      formik.resetForm();
      onCancel();
    } catch (err) {
      sendError(err);
    } finally {
      setLoading(false);
    }
  };

  const initialValues: OrganizationForm = {
    title: '',
    description: '',
  };

  const formik = useFormik<OrganizationForm>({
    initialValues: initialValues,
    validationSchema,
    onSubmit
  });

  const cancelAndReset = () => {
    formik.resetForm();
    onCancel();
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className='flex flex-wrap justify-between gap-4 px-2 pr-10'>
        <div className='flex flex-col gap-1.5 w-full'>
          <label className='text-xs font-light' htmlFor="title">Title</label>
          <CustomInput formik={formik} name="title" placeholder="Title" />
        </div>
        <div className='w-2/4' />

        <div className='flex flex-col w-full gap-2'>
          <label className='text-xs font-light' htmlFor="description">Description</label>
          <CustomTextarea formik={formik} name="description" placeholder="Description" />
        </div>

        <div className='w-2/4' />
      </div>

      <div className='flex justify-between w-full px-2 pt-10'>
        <Button type="ghost" onClick={cancelAndReset} className="w-2/5 btn-br-black">
          Cancel
        </Button>
        <Button loading={loading} type="ghost" htmlType="submit" className='w-2/5 btn-br-black'>
          Add Organization
        </Button>
      </div>
    </form>
  )
}